import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ProductReportService } from 'app/infrastructure/services/productreport.service';
import { TemplateListadoItem } from 'app/infrastructure/model/classes/templateListadoItem.class';

@Component({
    selector: 'sx-list-productreport',
    templateUrl: './list.productreport.component.html',
})
export class ListproductReportConfigurationComponent implements OnInit {
    systemCode: string;
    businessCode: string;
    productCode: string;
    reports: Observable<TemplateListadoItem[]>;

    constructor(
        private aRoute: ActivatedRoute,
        private reportService: ProductReportService,
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.businessCode = params['codnegocio'];
            this.productCode = params['codproducto'];
            this.reports = this.reportService.getTemplateList(this.systemCode, this.businessCode, this.productCode);
        });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/productReport/list.productreport.component.ts